import { useUserInfo } from '@/hooks/useUserInfo';
import React, { useEffect, useRef, useState } from 'react';
import { getSummary } from "@/utils/pasUtils.js";
import { any, object } from 'zod';
import {
  Printer
} from "lucide-react";
import { useLocation } from 'react-router-dom';

const ServiceCertificateRequestPrint = () => {
  const VITE_USERNAMET = import.meta.env.VITE_USERNAMET
  const VITE_PASSWORD = import.meta.env.VITE_PASSWORD

  const location = useLocation();
  const employeeData = location.state?.employeeData;
  const { greeting, fullName, email, role, profilePictureUrl } = useUserInfo();


  // console.log(email);

  const [isDetailed, setIsDetailed] = useState(employeeData?.employeeData?.type === 'detailed');
  const printableRef = useRef<HTMLDivElement>(null);

  const [data, setData] = useState({
    profile: null,
    salary_structure: null,
    salaryBasic: 0,
    salaryHousing: 0,
    salaryTransportation: 0,
    salaryAchievingGoals: 0,
    loading: true,
    error: null

  });

  useEffect(() => {
    async function fetchSalaryData() {
      try {
        const summaryResponse = await getSummary(VITE_USERNAMET, VITE_PASSWORD, email);
        if (data.loading) {
          setData(prev => ({
            ...prev,
            profile: summaryResponse.profile,
            salary_structure: summaryResponse.salary_structure,
            salaryBasic: summaryResponse.salary_structure.earnings[0].amount,
            salaryHousing: summaryResponse.salary_structure.earnings[1].amount,
            salaryTransportation: summaryResponse.salary_structure.earnings[2].amount,
            salaryAchievingGoals: summaryResponse.salary_structure.earnings[3].amount,
            loading: false,
            error: null
          }));

          // console.log(data)
        }
      } catch (err) {
        setData(prev => ({
          ...prev,
          loading: false,
          error: err.message
        }));
      }
      finally {
        // setLoading(false);
      }
    }

    fetchSalaryData();

    if (employeeData) {
      setIsDetailed(employeeData.type === 'detailed');
    }
  }, [data.loading, email, employeeData]);

  const handlePrint = () => {
    if (!printableRef.current) return; // Add null check

    const printContent = printableRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContents;
  };

  // Logo SVG component
  const Logo = () => (
    <img src="/src/assets/logo-dark.svg" className='w-36 text-left' />
  );
  const Signature = () => (
    <div className='relative w-max mx-auto'>
      <img src="/src/assets/wsmstamp.png" className='absolute w-48 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-50 ' />
      <div className="flex flex-col items-center justify-center">
        <h1 className='text-2xl font-bold mt-4'>إدارة الموارد البشرية</h1>
        <h1 className='text-2xl font-bold'>HR Department</h1>
      </div>

    </div>
  );

  const SalaryAr = () => {

    return (
      <span>
        {!isDetailed && <span > و يتقاضى المذكور راتب شهري قدره
          <strong>
            {
              (data?.salaryAchievingGoals ?? 0) +
              (data?.salaryBasic ?? 0) +
              (data?.salaryHousing ?? 0) +
              (data?.salaryTransportation ?? 0)
            }
          </strong>
          ريال سعودي فقط شامل جميع البدلات.</span>}
        {isDetailed && <span > و يتقاضى المذكور:
          <ul>
            <li>راتب شهريا أساسي قدره
              <strong> {data.salaryBasic} </strong>
              ريال سعودي ،
            </li>
            <li>
              و بدل سكن مبلغ و قدره
              <strong> {data.salaryHousing} </strong>
              ريال سعودي،
            </li>
            <li>
              و بدل نقل و قدره
              <strong> {data.salaryTransportation} </strong>
              ريال سعودي ،
            </li>
            <li>
              و بدل تحقيق أهداف
              <strong> {data.salaryAchievingGoals} </strong>
              ريال سعودي.
            </li>
          </ul>
        </span>}
      </span >
    );
  }
  const SalaryEn = () => {

    return (
      <span>
        {!isDetailed && (
          <span>
            And get paid a total monthly salary of{' '}
            <strong>
              {
                (data?.salaryAchievingGoals ?? 0) +
                (data?.salaryBasic ?? 0) +
                (data?.salaryHousing ?? 0) +
                (data?.salaryTransportation ?? 0)
              }
            </strong>
            {' '}Saudi Riyals, inclusive of all allowances.
          </span>
        )}
        {isDetailed && (
          <span>
            And get paid:
            <ul>
              <li>
                basic monthly salary of{' '}
                <strong> {data.salaryBasic} </strong>
                SAR,
                <li>housing allowance
                  <strong> {data.salaryHousing} </strong>
                  SAR</li>
                <li>transportation allowance
                  <strong> {data.salaryTransportation} </strong>
                  SAR</li>
                <li>achieving goals allowance
                  <strong> {data.salaryAchievingGoals} </strong>
                  SAR</li>.
              </li>
            </ul>
          </span>
        )}
      </span>
    );
  };

  const BilingualAREBDataRow = () => {
    if (data.loading) return <div className='flex justify-center'><img src="/src/assets/spinner.gif" alt="Loading..." /></div>;
    if (data.error) return <div>Error: {data.error}</div>;
    return (
      <div className='flex py-3'>
        <div className='w-1/2 p-4'>
          <p className="text-gray-600 mt-2">التاريخ: {new Date().toLocaleDateString()}</p>
          {/* <div className="font-normal text-gray-700 mt-3 underline">إلى من يهمه الأمر</div> */}
          <div className="font-normal text-gray-700 mt-3 underline">السادة: {employeeData.presentedToAr}</div>
          <div className="font-normal text-gray-700 mt-3">تحية طيبة،</div>
          <div className="font-normal text-gray-700 mt-3 text-justify">نفيدكم بأن السيد/ة <strong>{data.profile.full_name_arabic}</strong> {data.profile.nationality_arabic} الجنسية بموجب هوية رقم <strong>({data.profile.id_no}) </strong>
            يعمل لدينا من تاريخ <strong>{data.profile.date_of_joining}</strong> بوظيفة <strong>({data.profile.iqama_profession_arabic})</strong> ولايزال على رأس العمل حتى تاريخه.
            <br />
            <SalaryAr />
            <br /><br />
            وقد أعطي هذه الإفادة بناء على طلب الموظف و دون أدنى مسؤولية على الشركة.
            <br />
            شاكرين لكم حسن تعاونكم،
          </div>
        </div>
        <div className="flex-1 pl-4 text-left w-1/2 p-4" dir="ltr">
          <p className="text-gray-600 mt-2">Date: {new Date().toLocaleDateString()}</p>
          {/* <div className="font-normal text-gray-700 mt-3 underline">To Whome it may concern</div> */}
          <div className="font-normal text-gray-700 mt-3 underline">To Whome it may concern: {employeeData.presentedTo}</div>
          <div className="font-normal text-gray-700 mt-3">Greating,</div>
          <div className="font-normal text-gray-700 mt-3 text-justify">This to inform you that Mr/Mrs <strong>{data.profile.employee_name}</strong>, a {data.profile.nationality} Nationality with an ID / IQAMA NO  <strong>({data.profile.id_no})</strong>,
            is working with us up to date in a capacity of <strong>({data.profile.iqama_profession_english})</strong> from {data.profile.date_of_joining}.
            <br />
            <SalaryEn />
            <br />
            This certificate is provided at the request of the employee and does not impose any liability on the company.
          </div>
        </div>
      </div>
    );
  };

  if (!employeeData) {
    // Handle cases where data is missing (e.g., direct URL access)
    return <div>Error: Employee data not found for printing.</div>;
  }
  return (

    <div dir='rtl' className="min-h-full bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Printable content */}
        <div ref={printableRef} id="printable-content" className="p-8">
          {/* Header with logo and title */}
          <div className="flex justify-between items-start mb-8">
            <div className="w-full"></div> {/* Spacer for balance */}
            <Logo />
          </div>
          <div className="text-center flex-1">
            <h2 className="text-xl font-bold text-gray-800 mt-2" dir="rtl">خطاب تعريف عمل</h2>
            <h1 className="text-2xl font-bold text-gray-800">Identification Letter</h1>
          </div>
          <div className="mb-8">
            <BilingualAREBDataRow />
          </div>

          <div className='flex justify-center'>
            <Signature />
          </div>
        </div>
        {/* Print button */}
        <div className="flex justify-center p-6 bg-gray-50 border-t border-gray-200 print:hidden">
          <button
            onClick={handlePrint}
            className="w-48 bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors"
          >
            <Printer className="h-5 w-5" />
            طباعة
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCertificateRequestPrint;